export const EVENTS_VIEWS = ['calendar', 'list'] as const;
